<template>
  <div
    class="searchFilters form"
  >
    <h2
      class="section-heading"
    >
      {{ translations.results.faqmanualHeading }}
    </h2>
    <h2
      v-if="isMobile"
      class="searchFilters__cta"
      @click.prevent="onHeadingCtaClick"
    >
      {{ translations.filters.heading }}
      <span :class="[isActive ? 'arrow up' : 'arrow down']" />
    </h2>

    <div
      :class="{ 'section-heading': hasMadeAnySelections }"
      class="searchFilters__selected"
    >
      <ScChip
        v-if="internalKeyword"
        :value="internalKeyword"
        class="searchFilters__selected__item"
        ga-event-string="Systems Support Center, Search Filter, Remove Keyword"
        :aria-label="translations.filters.removeFilterLabel"
        @chip-clicked="removeKeywordSelection"
      >
        {{ internalKeyword }}

        <g-icon-close />
      </ScChip>

      <ScChip
        v-if="internalSelectedProductFamily && getInitialSelectedProductFamilyName"
        :value="internalSelectedProductFamily"
        class="searchFilters__selected__item"
        ga-event-string="Systems Support Center, Search Filter, Remove Product Family"
        :aria-label="translations.filters.removeFilterLabel"
        @chip-clicked="removeProductFamilySelection"
      >
        {{ getInitialSelectedProductFamilyName }}

        <g-icon-close />
      </ScChip>

      <ScChip
        v-if="internalSubtopic && getInitialSubTopicName"
        class="searchFilters__selected__item"
        :ga-event-string="`${systemConfig.mode} Systems Support Center,
        Search Filter,Remove Subtopic`"
        :value="internalSubtopic"
        :aria-label="translations.filters.removeFilterLabel"
        @chip-clicked="removeSubtopicSelection"
      >
        {{ getInitialSubTopicName }}

        <g-icon-close />
      </ScChip>

      <ScChip
        v-if="selectedProduct && getInitialSelectedProductName"
        class="searchFilters__selected__item"
        :ga-event-string="`${systemConfig.mode} Systems Support Center,
        Search Filter,Remove Subtopic`"
        :value="getInitialSelectedProductName"
        :aria-label="translations.filters.removeFilterLabel"
        @chip-clicked="removeProductSelection"
      >
        {{ getInitialSelectedProductName }}

        <g-icon-close />
      </ScChip>
    </div>

    <div
      v-if="isActive"
      class="searchFilters__options"
    >
      <div
        v-if="hasResults(getTagListTransformed(subTopics || []))"
        class="searchFilters__filter"
      >
        <label for="searchFilterSubtopics">
          {{ translations.filters.subtopicLabel }}
        </label>

        <select
          id="searchFilterSubtopics"
          v-model="internalSubtopic"
          @change="$emit('onSearchFilterSubtopicChange', internalSubtopic)"
        >
          <option :value="''">
            {{ translations.filters.dropDownSelectionText }}
          </option>
          <option
            v-for="topic in getTagListTransformed(subTopics || [])"
            :key="topic.value"
            :value="topic.value"
          >
            {{ topic.name }}
          </option>
        </select>
      </div>

      <div
        v-if="hasResults(productFamilyList || [])"
        class="searchFilters__filter"
      >
        <label for="searchFilterProductFamily">
          {{ translations.filters.productFamilyLabel }}
        </label>

        <select
          id="searchFilterProductFamily"
          v-model="internalSelectedProductFamily"
          @change="$emit('onSearchFilterProductFamilyChange', internalSelectedProductFamily)"
        >
          <option :value="''">
            {{ translations.filters.dropDownSelectionText }}
          </option>
          <option
            v-for="family in getTagListTransformed(productFamilyList || [])"
            :key="family.value"
            :value="family.value"
          >
            {{ family.name }}
          </option>
        </select>
      </div>

      <div class="searchFilters__filter searchFilters__products">
        <label for="searchFilterProduct">
          {{ translations.filters.productLabel }}
        </label>
        <ScAutocomplete
          unique-id="searchFilterProduct"
          item-text="displayName"
          :error-message="translations.filters.productFilterErrors.productError"
          with-free-form
          clear-button
          :input-attributes="{
            placeholder: translations.filters.productSearchPlaceholder
          }"
          :aria-label="translations.filters.productLabel"
          :initial-selected-item="internalSelectedProduct"
          :is-error-state="hasProductSearchError"
          :items="productList"
          :filter="(itemText, searchText) => autocompleteFilterFunc(itemText, searchText)"
          @item-selected="onSearchFilterProductSelected"
          @input="onSearchFilterProductInput"
          @input-cleared="removeProductSelection"
        />
      </div>

      <div class="searchFilters__filter">
        <label for="searchFilterKeyword">
          {{ translations.filters.keywordLabel }}
        </label>

        <input
          id="searchFilterKeyword"
          v-model="internalKeyword"
          :placeholder="translations.filters.keywordSearchText"
          type="search"
          data-hj-allow
          @change="$emit('onSearchFilterKeywordChange', internalKeyword)"
        >
      </div>
      <div class="searchFilters__action">
        <button
          :disabled="!canFilterChange"
          @click="onSearchFilterSubmit()"
        >
          {{ translations.filters.actionText }}
        </button>

        <button
          @click="onSearchFilterClear()"
        >
          {{ translations.filters.clearSearchCriteriaButtonLabel }}
        </button>
      </div>
    </div>
  </div>
</template>

<script src="./index.js"></script>

<style lang="scss" src="./style.scss"></style>
